import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'pager'
})
export class PagerPipe implements PipeTransform {

  transform(array: any[], page: {Size: number; Number: number; Total?: number; Pages?: number}, fullFinalPage: boolean = false): any[] {
    if (page && array?.length) {
      if (fullFinalPage) {
        const start = -page.Size * (page.Pages - page.Number);
        const end = page.Total - ((page.Pages - page.Number - 1) * page.Size);
        return array.slice(start, end);
      }
      return array.slice(page.Number * page.Size, page.Number * page.Size + page.Size);
    }
    return array;
  }
}
